<template>
  <div class="industry_zone_property_management">
    <!-- 左侧简介栏 -->
    <div class="pm_left">
      <div class="logo_container">
        <img
          class="logo"
          :src="
            industryZoneData.logo ||
            require('@/assets/img/SearchBar/logo_pm.png')
          "
          alt="logo"
        />
        <img
          class="free"
          src="@/assets/img/SearchBar/icon_free.png"
          alt="free"
        />
      </div>
      <div class="info_container">
        <div class="block">
          <p>
            <span>{{ industryZoneData.updateTodayCount }}</span
            >条
          </p>
          <p class="sm">今日更新</p>
        </div>
        <div class="divider" />
        <div class="block">
          <p>
            <span>{{ industryZoneData.weekTrend }}</span
            ><i class="iconfont icon-hot-up" />
          </p>
          <p class="sm">本周趋势</p>
        </div>
        <div class="divider" />
        <div class="block">
          <p>
            <span>{{ industryZoneData.specialHeat }}万</span>浏览
          </p>
          <p class="sm">专区热度</p>
        </div>
      </div>
      <div class="desc_container">
        {{ industryZoneData.content }}
      </div>
      <a
        target="_blank"
        class="pm_into_zone_btn"
        :href="`${INDUSTRY_ZONE_URL}?special=${keywords}&industryId=${industryZoneData.id}`"
        v-track
        :data-oid="OID_MAP.INDUSTRY_ZONE_PROPERTY_MANAGEMENT_ENTRY_CLICK"
        :data-cid="industryZoneData.id"
      >
        进入专区
      </a>
    </div>

    <!-- 右侧信息栏 -->
    <div class="pm_right">
      <IndustryZoneNewsBoard />
    </div>

    <!-- 背景图 -->
    <img
      class="property_management_bg"
      src="@/assets/img/SearchBar/property_management_industry_zone_bg.png"
      alt="bg"
    />
  </div>
</template>

<script>
import { INDUSTRY_ZONE_URL } from "@/utils/constants/constants.industry-zone";
import IndustryZoneNewsBoard from "@/components/LayoutHeaderSearch/components/IndustryZone/IndustryZoneNewsBoard";
import { DEED_MAP, OID_MAP } from "@/utils/constants/constants.track";

export default {
  name: "IndustryZonePropertyManagement",
  components: { IndustryZoneNewsBoard },
  data() {
    return {
      INDUSTRY_ZONE_URL,
      OID_MAP,
    };
  },
  computed: {
    industryZoneData() {
      return this.$store.getters["industryZone/industryZoneData"];
    },
    keywords() {
      return this.$store.getters["search/searchParams"].keywords;
    },
  },
  mounted() {
    this.$track(
      DEED_MAP.EXPOSURE,
      OID_MAP.INDUSTRY_ZONE_PROPERTY_MANAGEMENT_EXPOSURE,
      {
        ctx: this.industryZoneData.id,
      }
    );
  },
};
</script>

<style scoped lang="scss">
@import "../../../../assets/config";

.industry_zone_property_management {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;

  .pm_left {
    margin-top: 43px;

    .logo_container {
      display: flex;

      .logo {
        width: 132px;
        height: 40px;
      }

      .free {
        width: 32px;
        height: 16px;
        margin-top: 6px;
        margin-left: 8px;
      }
    }

    .info_container {
      display: flex;
      align-items: center;
      margin-top: 15px;

      .block {
        font-size: 14px;

        p {
          display: flex;

          span {
            color: $industry-zone-theme-color;
          }

          i {
            font-size: 12px;
            color: #e65934;
            margin-top: -2px;
            margin-left: 2px;
          }
        }

        .sm {
          font-size: 12px;
        }
      }

      .divider {
        width: 1px;
        height: 22px;
        background-color: #a8c2fd;
        margin: 0 16px;
      }
    }

    .desc_container {
      font-size: 16px;
      margin-top: 32px;
      width: 368px;
    }

    .pm_into_zone_btn {
      display: block;
      font-size: 16px;
      margin-top: 32px;
      width: 136px;
      height: 40px;
      line-height: 40px;
      background: $industry-zone-theme-color;
      border-radius: 4px;
      text-align: center;
      color: white;
    }
  }

  .pm_right {
    margin-top: 38px;
  }

  // 背景图
  .property_management_bg {
    width: 534px;
    height: 305px;
    object-fit: contain;
    object-position: center center;

    position: absolute;
    bottom: 0;
    left: 188px;
  }
}
</style>
